import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "sticky-header",
  class StickyHeader extends WYATTElement {
    connectedCallback() {
      this.header = document.querySelector("header");
      this.currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector("predictive-search");
      this.hoverIntent = this.querySelector("hover-intent");
      this.scrollBuffer = 5;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.addEventListener("scroll", this.onScrollHandler, false);

      this.createObserver();
      this.announceHeaderHeight();
    }

    disconnectedCallback() {
      this.removeEventListener(
        "preventHeaderReveal",
        this.hideHeaderOnScrollUp,
      );
      window.removeEventListener("scroll", this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obsrvr) => {
        this.headerBounds = entries[0].intersectionRect;
        obsrvr.disconnect();
      });

      observer.observe(this.header);
    }

    announceHeaderHeight() {
      const headerHeight = this.header.getBoundingClientRect().height;
      document.documentElement.style.setProperty(
        "--header-height",
        `${headerHeight}px`,
      );
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.hoverIntent && this.hoverIntent.isOpen) return;

      if (scrollTop > this.header.getBoundingClientRect().height) {
        this.header.setAttribute("sticky-header", "true");
        this.header.isActive = true;
      } else {
        this.header.setAttribute("sticky-header", "false");
        this.header.isActive = false;
      }

      if (scrollTop < this.headerBounds?.bottom) {
        requestAnimationFrame(this.reset.bind(this));
      } else if (
        scrollTop > this.currentScrollTop + this.scrollBuffer &&
        scrollTop > this.headerBounds?.bottom
      ) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop - this.scrollBuffer &&
        scrollTop > this.headerBounds?.bottom
      ) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          let isScrolling;

          window.clearTimeout(isScrolling);

          isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds?.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.setAttribute("sticky-header-hidden", true);
    }

    reveal() {
      this.header.setAttribute("sticky-header-hidden", false);
    }

    reset() {
      this.header.setAttribute("sticky-header-hidden", false);
    }
  },
);
